import React from 'react';
import { MEAL_PRESETS } from './addressStatus';

export const MealSelect = ({ value, onChange, testId, className = '', options, placeholder = '—' }) => {
  const list = options?.length ? options : MEAL_PRESETS;
  const v = value && value !== '—' ? value : '';
  const opts = v && !list.includes(v) ? [...list, v] : list;
  return (
    <select data-testid={testId} value={v} onChange={(e) => onChange(e.target.value || '—')}
      className={`bg-transparent text-xs rounded border border-[#EFE3D8] px-1.5 py-1 focus:outline-none focus:border-[#7B2C3B] ${className}`}>
      <option value="">{placeholder}</option>
      {opts.map((m) => <option key={m} value={m}>{m}</option>)}
    </select>
  );
};

export default MealSelect;
